/**
 * Algolia User tokens and authenticated tokens must contain only:
 * - alphanumeric,
 * - equal,
 * - plus,
 * - slash,
 * - hyphen,
 * - underscores,
 * - be between 1 and 129 characters long
 *
 * @link https://support.algolia.com/hc/en-us/articles/27738943151249-Why-am-I-receiving-a-422-error-How-to-debug-your-events
 * @param token {string} - The user token to sanitize
 * @returns {string} sanitized token
 */
export function sanitizeAlgoliaToken(token?: string | null): string | undefined {
    if (!token) {
        return undefined;
    }

    const regex = /[^a-zA-Z0-9=+\/\-_]/g;
    const sanitizedToken = token.replace(regex, '_');

    return sanitizedToken.length > 129 ? sanitizedToken.substring(0, 129) : sanitizedToken;
}
